export default "Daniela’s place was great! The apartment has everything me and my husband needed for a few days stay. :)";